export const fillEmptyWithHyphen = (value) =>
  value === null || value === "" ? "-" : value;
